(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_9ccfe8e"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('merlons-home-category-grid')) {
    customElements.define('merlons-home-category-grid', class extends HTMLElement {
      connectedCallback() {
        this.onFilter = (event) => {
          const button = event.target.closest('button[data-category-filter]');
          if (!button || !this.contains(button)) return;
          const selected = button.dataset.categoryFilter;
          let count = 0;
          this.querySelectorAll('[data-card-group]').forEach((card) => {
            card.hidden = selected !== 'all' && card.dataset.cardGroup !== selected;
            if (!card.hidden) count += 1;
          });
          this.querySelectorAll('[data-category-filter]').forEach((item) => {
            item.setAttribute('aria-pressed', String(item === button));
          });
          const status = this.querySelector('[data-category-status]');
          if (status) status.textContent = `${button.textContent.trim()}: ${count} ${status.dataset.countLabel}`;
        };
        this.addEventListener('click', this.onFilter);
        const controls = this.querySelector('[data-category-controls]');
        if (controls) controls.hidden = false;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onFilter);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
